import React from "react";
import Meaning from "./Meaning";
import Phonetic from "./Phonetic";
import "./Results.css";

export default function Results(props) {
  //recieve props from Dictionary
  // console.log(props.results);

  if (props.results) {
    //if result is not empty, we show response, to see how looks response< just check /console.log(props.results);
    return (
      <div className="Results">
        {" "}
        <section className="How-to-spell">
          <h3>{props.results.word}</h3>
          <Phonetic phonetics={props.results.phonetics} />
        </section>
        {props.results.meanings.map(function (meaning, index) {
          //mapping meaning list
          return (
            <div key={index} className="result">
              <section>
                <Meaning meaning={meaning} />
              </section>
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}
